export default {
	props: {
		value: {
			type: [String, null]
		},
		size: {
			type: String,
			default: ''
		},
		quality: {
			type: Number,
			default: 0.85
		}
	},

	data() {
		return {
			uid: this.value,
			uploader: null
		}
	},

	template: `
		<div class="image-uploader"
			:data-size="size"
			:data-quality="quality.toString()"
			>
			<input type="text" placeholder="Image Uploader"
				v-model="uid"
				ref="fileInput"
				@change="updateChange"
				>
		</div>
	`,

	mounted() {
		this.uploader = new zzl.uploader.ImageUploader(this.$el)
	},

	beforeDestroy() {
		// TODO: make ImageUploader destroyable
		// this.uploader.destroy()
	},

	methods: {
		updateChange() {
			this.$emit('input', this.$refs.fileInput.value)
		}
	}
}
